import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'primerTecnico'
})
export class PrimerTecnicoPipe implements PipeTransform
{
  transform(value: string)  : string
  {
    if (!value) return '';
    return value.split('<br>')[0];
  }
}
